import { createGlobalStyle } from "styled-components";
import {
  addCSSVariablesToHTML,
  convertRecordToCSSVariables,
  revertCSSVariable,
  updateCSSVariable,
} from "manifest-core/utils/cssVariables";
import { ColorVariables } from "../Colors";

export const baseLength = 4;
export const sm = 2 * baseLength;
export const md = 3 * baseLength;
export const lg = 4 * baseLength;
export const xl = 5 * baseLength;

export const GlobalStyleDefaults = {
  mobileBreakpoint: "768px",
  mobileWidth: `330px`,
  desktopWidth: `600px`,
  sm: `${sm}px`,
  md: `${md}px`,
  lg: `${lg}px`,
  xl: `${xl}px`,
};

const GlobalCSS = createGlobalStyle`
  html {
    overflow-y: scroll;
    overflow-x: hidden;
    scroll-behavior: smooth;
    font-family: 'Work Sans', sans-serif;
    color: ${ColorVariables.coco};
  }
  
  html.allow-overflow {
    overflow-x: auto;
  }
  
  html,
  body {
    padding: 0px;
    margin: 0px !important;
    width: 100%;
    height: 100%;
    background-color: var(--manifest-background);
  }
  
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
  
  div + div {
    margin: 0px;
    padding: 0px;
  }
  
  img {
    margin: 0px;
    padding: 0px;
  }
  
  /* Interactive */
  
  .block {
    display: block;
  }
  
  .relative {
    position: relative;
  }
  
  .clickable {
    cursor: pointer;
  }
  
  .clickable:hover {
    opacity: 0.8;
  }
  
  a {
    color: ${ColorVariables.mint};
  }
  
  /* WIDTH RELATED */
  
  .fullWidth {
    width: 100%;
  }
  
  .full-width {
    width: 100%;
  }
  
  /* DISPLAY RELATED */
  
  .hide {
    display: none !important;
  }
  
  .hide-on-desktop {
    display: none;
  }
  
  .hide-on-mobile {
    display: inherit;
  }
  
  .left-text {
    text-align: left;
  }
  
  .right-text {
    text-align: right;
  }
  
  .center-text {
    text-align: center;
  }
  
  .center-on-desktop {
    text-align: center;
  }
  
  .center-on-mobile {
    text-align: inherit;
  }
  
  .break-on-mobile {
    display: none;
  }

  .no-underline{
    text-decoration: none
  }

  .no-padding-bottom{
    padding-bottom:0 !important;
  }
  
  @media (max-width: ${getMobileBreakpoint}) {
    .hide-on-desktop {
      display: inherit;
    }
  
    .hide-on-mobile {
      display: none;
    }
  
    .center-on-desktop {
      text-align: inherit;
    }
  
    .center-on-mobile {
      text-align: center;
    }
  
    .break-on-desktop {
      display: none;
    }
  }
`;

export function getGlobalStyle(property: keyof typeof GlobalStyleDefaults) {
  return (userProps: any) => {
    const props = userProps as Partial<{ theme: typeof GlobalStyleDefaults }>;
    if (props.theme && props.theme[property]) {
      return props.theme[property];
    }
    return GlobalStyleDefaults[property];
  };
}

export function getMobileBreakpoint(userProps: any) {
  const props = userProps as Partial<{ theme: typeof GlobalStyleDefaults }>;
  if (props.theme && props.theme.mobileBreakpoint) {
    return props.theme.mobileBreakpoint;
  }
  return GlobalStyleDefaults.mobileBreakpoint;
}

export const globalCSSVars = convertRecordToCSSVariables(GlobalStyleDefaults);
export const updateGlobalCSSVars = updateCSSVariable(GlobalStyleDefaults);
export const revertGlobalCSSVars = revertCSSVariable(GlobalStyleDefaults);
addCSSVariablesToHTML(GlobalStyleDefaults);

export default GlobalCSS;
